<div class="filter-block"
     [class.move-top]="top && (isAuthenticated || isMeVersion())"
     [class.no-padding]="isPageWithPadding"
     [class.mobile]="deviceService.isMobile()">
  <div class="filter-scroll">
    <ul class="filter-list">
      <li *ngFor="let filter of tabs; trackBy: trackByFn"
          class="filter-item"
          [attr.data-test]="filter.code"
          [class.selected]="activeTab?.id ? (filter.id === activeTab?.id) : (filter.code === activeTab?.code)"
          (click)="onSelectItem(filter)">
        <span class="filter-label">{{ filter.title | translate }}</span>
      </li>
    </ul>
  </div>
  <ng-content select="[action]"></ng-content>
</div>
